import React from 'react';
import './Accordion.css'; // Bu stil dosyasını da oluşturacağız

const AccordionItem = ({ id, title, content, isOpen, onToggle }) => {
    return (
        <div className="accordion-item">
            <div className="accordion-header" onClick={() => onToggle(id)}>
                <h4 className="accordion-title">{title}</h4>
                <i className={`fas fa-chevron-down accordion-icon ${isOpen ? 'open' : ''}`}></i>
            </div>
            <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                <div className="accordion-content-inner">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default AccordionItem;